import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditCourse from "../../../Components/CoursesModuleComponents/AddOrEditCourse";
import { useEffect, useState } from "react";
import { getCourseDataForUpdate, getCourseName } from "../../../apis";
import { useParams } from "react-router-dom";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import { getTotalMinutes } from "../../../_helper";

const UpdateCourse = () => {
  const { courseId } = useParams();
  const [courseName, setCourseName] = useState("");
  const [courseData, setCourseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState("");

  useEffect(() => {
    setIsLoading(true);
    getCourseName(courseId).then((response) => {
      setCourseName(response.data.name);
    });
    getCourseDataForUpdate(courseId)
      .then((response) => {
        setCourseData(response.data);
      })
      .catch((error) => {
        setIsError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [courseId]);

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;

  console.log();

  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Course Details", link: `/courses-management/${courseId}` },

          { title: "Update Course" },
        ]}
      />
      <h2 className="h4">
        Edit In <span className="tw-text-primary">{courseName || ""}</span>{" "}
        Course
      </h2>
      <AddOrEditCourse
        mode="edit"
        initialValuesForEdit={{
          titleEn: courseData?.course_name_en || "",
          titleAr: courseData?.course_name_ar || "",
          descriptionEn: courseData?.course_description_en || "",
          descriptionAr: courseData?.course_description_ar || "",
          courseType: courseData?.course_type || "",
          courseLevel: courseData?.course_level || "",
          coursePriceEm: courseData?.e_money ?? "",
          coursePriceEg: courseData?.course_price || "",
          pvUplinerValue: courseData?.weight ?? "",
          directEMoney: courseData?.pv_direct_value ?? "",
          prerequisiteCourse: courseData?.prerequisite_course_id || "",
          instructorName: courseData?.instructor_id || "",
          isDisplayedToPartner: courseData?.is_partner_displayed || "1",
          isSitePublished: courseData?.is_web_published || "1",
          courseRating: courseData?.rating || "",
          isActive: courseData?.is_active || "1",
          confirm: false,
          promoVideo: courseData?.promo_video || "",
        }}
        imageForEdit={courseData?.image || ""}
      />
    </>
  );
};

export default UpdateCourse;
